import React, { useState, useEffect, useContext } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import {
  TextField,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  FormControl,
  InputLabel,
  IconButton,
  OutlinedInput,
  FormHelperText
 } from "@mui/material/";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { cambiarProveedor } from "../../../services/proveedor.service";
import { useTranslation } from "react-i18next";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { municipiosIniciales, cambiarFormatoNombre } from "../../../functions/funciones";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import LaeButton from "../../../components/Buttons/LaeButton";
import { verificarCorreo, verificarTelefono , verificarCodigoPostal, verificarFecha } from "../../../functions/validator/formValidator";
import { useNavigate } from "react-router-dom";
import { UsuarioContext } from "../../../providers/userContext";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85ch",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const modal = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};


export default function TransitionsModal(props) {
  const { t } = useTranslation(['suppliers', 'common']);
  const usuario = useContext(UsuarioContext);
  const limitarReclamacion = usuario?.rol !== "ADMIN";
  const maxReclamacionFecha = (() => {
    const max = new Date();
    max.setDate(max.getDate() + 7);
    const m = max.getMonth() + 1 < 10 ? "0" + (max.getMonth() + 1) : max.getMonth() + 1;
    const dd = max.getDate() < 10 ? "0" + max.getDate() : max.getDate();
    return max.getFullYear() + "-" + m + "-" + dd;
  })();
  const formatFecha = (fecha) => {
    const f = new Date(fecha);
    const m = f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1;
    const dia = f.getDate() < 10 ? "0" + f.getDate() : f.getDate();
    return f.getFullYear() + "-" + m + "-" + dia;
  };
  const hoyFecha = formatFecha(new Date());
  const maxProximaReclamacion = (() => {
    const max = new Date();
    max.setMonth(max.getMonth() + 4);
    return formatFecha(max);
  })();
  // El backend marca con permitestandBy qué estados permiten activar el standBy
  const permitestandBy = (estadoId) => {
    const estado = estados.find((e) => e.id === estadoId);
    return estado?.permiteStandBy === true;
  };
  var d = new Date(
    props.proveedor.ultimaReclamacion === null
      ? props.proveedor.createdAt
      : props.proveedor.ultimaReclamacion
  );
  var mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  var dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
  var yy = d.getFullYear();
  let nuevoFormato = yy + "-" + mm + "-" + dd;

  const navigate = useNavigate();
  const [editarDatos, setEditarDatos] = useState({});
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [activo, setActivo] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true);
  const [estados, setEstados] = useState([]);

  useEffect(() => {
    const estados = JSON.parse(localStorage.getItem("statesSupps")) || [];
    setEstados(estados);
    setServicios(props?.servicios?.data || []);
    const proveedor = {
      nif: props.proveedor.nif,
      id: props.proveedor.id,
      razonSocial: props.proveedor.razonSocial,
      direccion: props.proveedor.direccion,
      nif: props.proveedor.nif,
      municipio: props.proveedor.municipio,
      nombreContacto: props.proveedor.nombreContacto,
      codigoPostal: props.proveedor.codigoPostal,
      emailLogin: props.proveedor.user?.email ? props.proveedor.user.email.trim() : "",
      emailContacto: props.proveedor.emailContacto ? props.proveedor.emailContacto.trim() : "",
      provincia: props.proveedor.provincia,
      telefonoContacto: props.proveedor.telefonoContacto,
      ultimaReclamacion: nuevoFormato,
      trabajadores: props.proveedor.noProcede,
      servicios: props.proveedor.serviceSupps?.map(s => s.id) || [],
      estado_id: props.proveedor.estado_id ?? "",
      standBy: props.proveedor.standBy ?? null,
      proximaReclamacion: props.proveedor.proximaReclamacion ? formatFecha(props.proveedor.proximaReclamacion) : "",
      // comentarios: props.proveedor.comentarios,
    };
    setEditarDatos(proveedor);
    setListadoMunicipios(municipiosIniciales(provinces, municipalities, props.proveedor.provincia))
  }, [props]);
  function handleEditClick () {
    setIsDisabled(!isDisabled); 
  };

  function handleChange(evt) {
    const value = evt.target.value;
    if (evt.target.name === "estado_id") {
      // Al cambiar de estado, si el nuevo no permite standBy se fuerza a "No"
      const permite = permitestandBy(value);
      setEditarDatos({
        ...editarDatos,
        estado_id: value,
        standBy: permite ? editarDatos.standBy : false,
        // Si el standBy queda en "No", se vacía la próxima reclamación
        proximaReclamacion: permite ? editarDatos.proximaReclamacion : "",
      });
      return;
    }
    if (evt.target.name === "standBy") {
      // Si el standBy es "No", se vacía la próxima reclamación
      const esStandBy = value === "true" || value === true;
      setEditarDatos({
        ...editarDatos,
        standBy: value,
        proximaReclamacion: esStandBy ? editarDatos.proximaReclamacion : "",
      });
      return;
    }
    setEditarDatos({
      ...editarDatos,
      [evt.target.name]: value,
    });
  }

  // Valor original del proveedor (mismo formato que en el estado).
  const proximaReclamacionOriginal = props.proveedor.proximaReclamacion
    ? formatFecha(props.proveedor.proximaReclamacion)
    : "";

  // Solo se valida el rango cuando el valor difiere del original (el usuario lo ha cambiado).
  // Una fecha que quedó fuera de rango por el paso del tiempo, sin tocarla, no avisa ni bloquea.
  const proximaReclamacionFueraRango =
    !!editarDatos.proximaReclamacion &&
    editarDatos.proximaReclamacion !== proximaReclamacionOriginal &&
    (editarDatos.proximaReclamacion < hoyFecha ||
      editarDatos.proximaReclamacion > maxProximaReclamacion);

  // Sólo se considera "en Stand By" cuando el valor seleccionado es "Sí".
  const esStandBySi =
    editarDatos.standBy === true || editarDatos.standBy === "true";

  // Si el campo está habilitado (el estado permite stand by y está en "Sí") y está vacío, es obligatorio.
  const proximaReclamacionVaciaObligatoria =
    permitestandBy(editarDatos.estado_id) && esStandBySi && !editarDatos.proximaReclamacion;

  const editar = (proveedor) => {
    if (proximaReclamacionVaciaObligatoria) {
      toast.error(
        t('editModal.nextReclamationRequired', { defaultValue: 'La próxima reclamación es obligatoria' })
      );
      return;
    }
    if (proximaReclamacionFueraRango) {
      toast.error(
        t(
          'editModal.nextReclamationAdvice'
        )
      );
      return;
    }
    if (limitarReclamacion && proveedor.ultimaReclamacion) {
      const seleccionada = new Date(proveedor.ultimaReclamacion);
      const limite = new Date(maxReclamacionFecha);
      limite.setHours(23, 59, 59, 999);
      if (isNaN(seleccionada.getTime()) || seleccionada > limite) {
        toast.error(t('messages.reclamacionMaxAWeek', 'La fecha de reclamación no puede ser posterior a una semana desde hoy'));
        return;
      }
    }
    setActivo(true);
    let data = {
      razonSocial: proveedor.razonSocial,
      direccion: proveedor.direccion,
      nif: proveedor.nif,
      municipio: proveedor.municipio,
      nombreContacto: proveedor.nombreContacto,
      codigoPostal: proveedor.codigoPostal,
      emailLogin: proveedor.emailLogin,
      emailContacto: proveedor.emailContacto,
      provincia: proveedor.provincia,
      telefonoContacto: proveedor.telefonoContacto,
      ultimaReclamacion: proveedor.ultimaReclamacion,
      noProcede: proveedor.trabajadores === null ? true : proveedor.trabajadores,
      servicios: proveedor.servicios,
      serviciosEliminados: proveedor.serviciosEliminados,
      estado_id: proveedor.estado_id === "" ? null : proveedor.estado_id,
      standBy: proveedor.estado_id === "" || proveedor.estado_id === null || proveedor.estado_id === undefined
        ? null
        : permitestandBy(proveedor.estado_id)
          ? proveedor.standBy === true || proveedor.standBy === "true"
          : false,
      proximaReclamacion: proveedor.proximaReclamacion || null,
      // comentarios: proveedor.comentarios
    };
    const toastInfo = toast.info(t('messages.saving'), { autoClose: false });
    cambiarProveedor(props.proveedor.nif, data)
      .then((res) => {
        let keys = Object.keys(data);
        let errores = false;
        const urlActual = window.location.pathname + window.location.search;

        // Expresión regular para reemplazar solo el NIF en la parte correcta de la URL
        const nuevaUrl = urlActual.replace(
          new RegExp(`proveedores/${props.proveedor.nif}`),
          `proveedores/${proveedor.nif}`
        );
        // Cambiar la URL sin recargar la página
        navigate(nuevaUrl, { replace: true });

        // keys.forEach(key => {
        //   switch (key) {

        //     case "emailContacto":

        //       let correoCorrecto = verificarCorreo(data.emailContacto);
        //       if (correoCorrecto === false) {
        //         toast.error("El email de contacto es incorrecto");
        //         errores = true;
        //         setActivo(false)
        //       }
        //       break;
        //     case "codigoPostal":

        //       let codigoPostalCorrecto = verificarCodigoPostal(data.codigoPostal);
        //       if (codigoPostalCorrecto === false) {
        //         toast.error("El codigo postal introducido es incorrecto");
        //         errores = true;
        //         setActivo(false)
        //       }
        //       break;
        //     case "telefonoContacto":

        //       let telefonoCorrecto = verificarTelefono(data.telefonoContacto);
        //       if (telefonoCorrecto === false) {
        //         toast.error("El teléfono  es incorrecto");
        //         errores = true;
        //         setActivo(false)
        //       }
        //       break;
        //     case "ultimaReclamacion":

        //       let fechaReclamacionCorrecta = verificarFecha(data.ultimaReclamacion);
        //       if (fechaReclamacionCorrecta === false) {
        //         toast.error("La fecha de ultima reclamación no puede ser superior a la actual");
        //         errores = true;
        //         setActivo(false)
        //       }
        //       break;

        //     default:
        //       break;
        //   }
        // });

        if (!errores && res.status >= 200 && res.status < 300) {
          toast.update(toastInfo, {
            render: t('editModal.saveSuccess'),
            type: toast.TYPE.SUCCESS,
            autoClose: true,
          });
          props.handleClose();
          props.hijoAPadre();
          setActivo(false)
        } else{
          toast.update(toastInfo, {
            render: t('editModal.saveError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        }

      })
      .catch((err) => {
        console.log(err)
        toast.update(toastInfo, {
          render: t('editModal.unknownError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
        setActivo(false)
      });
    
  };
  const changeServicios = (evt) => {
    const {name, value} = evt.target;
    const nuevosIds = value;
    const serviciosOriginales = props.proveedor.serviceSupps || [];
    const delServicios = serviciosOriginales.filter(
    s => !nuevosIds.includes(s.id)
    ).map(s => s.id);
    const nuevoEstado = {
      ...editarDatos,
      [name]: value,
      serviciosEliminados: delServicios
    };
    setEditarDatos(nuevoEstado);
  }
  const seleccionarMunicipios = (e) => {
    const nombreProvincia = e.target.value;
    const provinciaSeleccionada = provinces.find(p => p.name === nombreProvincia);
    const codProvincia = provinciaSeleccionada ? provinciaSeleccionada.code : "";

    const municipiosFiltrados = municipalities
    .filter(m => m.provCode === codProvincia)
    .map(m => ({
      ...m,
      name: cambiarFormatoNombre(m.name),
      value: m.name
    }));

    setEditarDatos(prevState => ({
      ...prevState,
      [e.target.name]: nombreProvincia
    }));

    setListadoMunicipios(municipiosFiltrados);
    // let codProvincia = ""
    // let municipios = []
    // console.log("asdasdasd")
    // provinces.map(p => {
    //   if (p.name === e.target.value) {
    //     codProvincia = p.code
    //   }
    // })
    // setEditarDatos({
    //   ...editarDatos,
    //   [e.target.name]: e.target.value
    // });
    // municipalities.map(m => {
    //   if (m.provCode === codProvincia) {
    //     municipios.push({ ...m, name: cambiarFormatoNombre(m.name), value: m.name })
    //   }
    // })
    // setListadoMunicipios(municipios)
  }

  return (
    <div>
      <Modal
        sx={modal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={modal}
        open={props.opened}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box sx={style}>
          <div
            style={{
              backgroundColor: "#fff",
              border: "2px solid #000",
              boxShadow:
                "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
              padding: "16px 32px 24px",
            }}
          >
            <h2 id="transition-modal-title">{t('editModal.title')}</h2>
            <div id="transition-modal-description">
              <form noValidate autoComplete="off">
                <div
                  style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <TextField
                    id="nif"
                    name="nif"
                    label={t('editModal.fields.nif')}
                    value={editarDatos.nif}
                    onChange={handleChange}
                  />
                  <TextField
                    id="razonSocial"
                    name="razonSocial"
                    label={t('editModal.fields.supplierName')}
                    value={editarDatos.razonSocial}
                    onChange={handleChange}
                  />
                  <TextField
                    id="direccion"
                    name="direccion"
                    label={t('editModal.fields.address')}
                    value={editarDatos.direccion}
                    onChange={handleChange}
                  />
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="provincia">{t('editModal.fields.province')}</InputLabel>
                    <Select
                      label={t('editModal.fields.province')}
                      name="provincia"
                      id="provincia"
                      style={{ textTransform: 'uppercase' }}
                      onChange={(e) => {
                        seleccionarMunicipios(e);
                      }}
                      value={editarDatos?.provincia || ""}
                    >
                      <MenuItem value={props.proveedor.provincia || ""}>{props.proveedor.provincia || t('editModal.fields.province').toLowerCase()}</MenuItem>
                      {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                        return (
                          <MenuItem key={i} value={e.name}>
                            {e.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="municipio">{t('editModal.fields.municipality')}</InputLabel>
                    <Select
                      label={t('editModal.fields.municipality')}
                      name="municipio"
                      id="municipio"
                      style={{ textTransform: 'uppercase' }}
                      onChange={handleChange}
                      defaultValue={editarDatos?.municipio}
                    >
                      <MenuItem value={props.proveedor.municipio || ""}>{props.proveedor.municipio || t('editModal.fields.municipality').toLowerCase()}</MenuItem>
                      {listadoMunicipios.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                        return (
                          <MenuItem key={i} value={e.value}>
                            {e.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    id="nombreContacto"
                    name="nombreContacto"
                    label={t('editModal.fields.contactPerson')}
                    value={editarDatos.nombreContacto}
                    onChange={handleChange}
                  />
                  <TextField
                    id="emailContacto"
                    name="emailContacto"
                    label={t('editModal.fields.contactEmail')}
                    value={editarDatos.emailContacto}
                    onChange={handleChange}
                  />
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-edit">{t('editModal.fields.loginEmail')}</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-edit"
                      type={'text'}
                      defaultValue={editarDatos.emailLogin ?? ''}
                      name="emailLogin"
                      disabled={isDisabled}
                      onChange={handleChange}
                      error={isDisabled}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleEditClick}
                            // onMouseDown={handleMouseDownPassword}
                            // onMouseUp={handleMouseUpPassword}
                            edge="end"
                          >
                            {<EditIcon />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label={t('editModal.fields.loginEmail')}
                    />
                    {!isDisabled && (
                      <FormHelperText error>⚠️{t('editModal.loginEmailWarning')}</FormHelperText>
                    )}
                  </FormControl>
                  <TextField
                    id="codigoPostal"
                    type="number"
                    name="codigoPostal"
                    label={t('editModal.fields.postalCode')}
                    value={editarDatos.codigoPostal}
                    onChange={handleChange}
                  />
                  <TextField
                    id="telefonoContacto"
                    type="tel"
                    name="telefonoContacto"
                    label={t('editModal.fields.phone')}
                    value={editarDatos.telefonoContacto}
                    onChange={handleChange}
                  />
                  <TextField
                    id="ultimaReclamacion"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="ultimaReclamacion"
                    label={t('editModal.fields.lastReclamation')}
                    defaultValue={editarDatos.ultimaReclamacion}
                    onChange={handleChange}
                    inputProps={limitarReclamacion ? { max: maxReclamacionFecha } : undefined}
                  />
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="trabajadores">{t('editModal.fields.workers')}</InputLabel>
                    <Select
                      label={t('editModal.fields.workers')}
                      native
                      name="trabajadores"
                      id="trabajadores"
                      style={{ textTransform: 'uppercase' }}
                      onChange={handleChange} defaultValue={editarDatos?.trabajadores}
                    >
                      <option value={false}>{t('common:status.yes')}</option>
                      <option value={true}>{t('common:status.no')}</option>
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel id="servicios-label">{t('editModal.fields.services')}</InputLabel>
                    <Select
                      id="servicios-select"
                      label={t('editModal.fields.services')}
                      name="servicios"
                      value={
                        Array.isArray(editarDatos.servicios)
                          ? editarDatos.servicios
                          : []
                      }
                      onChange={changeServicios}
                      multiple
                    >
                      {/* <MenuItem value="" style={{ height: 40 }}></MenuItem> */}
                      {servicios.length > 0 && servicios.map((e) => {
                        return (
                          <MenuItem key={e.id} value={e.id}>
                            {e.nombre}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel id="estado_id-label">{t('editModal.fields.state')}</InputLabel>
                    <Select
                      labelId="estado_id-label"
                      id="estado_id"
                      label={t('editModal.fields.state')}
                      name="estado_id"
                      value={editarDatos.estado_id ?? ""}
                      onChange={handleChange}
                    >
                      {estados.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                          {t(`common:stateNamesSupps.${e.nombre}`, e.nombre)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="standBy">{t('editModal.fields.standBy')}</InputLabel>
                    <Select
                      label={t('editModal.fields.standBy')}
                      native
                      name="standBy"
                      id="standBy"
                      style={{ textTransform: 'uppercase' }}
                      onChange={handleChange}
                      disabled={!permitestandBy(editarDatos.estado_id)}
                      value={
                        editarDatos.estado_id === "" || editarDatos.estado_id === null || editarDatos.estado_id === undefined
                          ? ""
                          : permitestandBy(editarDatos.estado_id)
                            ? String(editarDatos.standBy ?? false)
                            : "false"
                      }
                    >
                      <option value="" hidden>-</option>
                      <option value={false}>{t('common:status.no')}</option>
                      <option value={true}>{t('common:status.yes')}</option>
                    </Select>
                  </FormControl>
                  <TextField
                    id="proximaReclamacion"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="proximaReclamacion"
                    label={t('editModal.fields.nextReclamation')}
                    value={editarDatos.proximaReclamacion || ""}
                    onChange={handleChange}
                    disabled={!permitestandBy(editarDatos.estado_id) || !esStandBySi}
                    inputProps={{ min: hoyFecha, max: maxProximaReclamacion }}
                    error={proximaReclamacionFueraRango || proximaReclamacionVaciaObligatoria}
                  />
                  {proximaReclamacionVaciaObligatoria && (
                    <span
                      style={{
                        gridColumn: "1 / -1",
                        color: "#d32f2f",
                        fontSize: "12px",
                      }}
                    >
                      ⚠️{" "}
                      {t('editModal.nextReclamationRequired', { defaultValue: 'La próxima reclamación es obligatoria' })}
                    </span>
                  )}
                  {proximaReclamacionFueraRango && (
                    <span
                      style={{
                        gridColumn: "1 / -1",
                        color: "#d32f2f",
                        fontSize: "12px",
                      }}
                    >
                      ⚠️{" "}
                      {t(
                        'editModal.nextReclamationAdvice'
                      )}
                    </span>
                  )}
                </div>
                
                <div
                  style={{
                    margin: "8px",
                    width: "100ch",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: " repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      flex: 1,
                      backgroundColor: "whitesmoke",
                      color: "#92004D",
                      ":hover": { backgroundColor: "#92004D", color: "white" },
                      margin: 0,
                      p: 1,
                    }}
                    disableElevation
                    onClick={props.handleClose}
                  >
                    {t('common:actions.cancel')}
                  </Button>
                  <LaeButton
                    sx={{ flex: 1 }}
                    onClick={() => editar(editarDatos)}
                    disabled={proximaReclamacionFueraRango}
                  >
                    {t('common:actions.save')}
                  </LaeButton>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
